function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".remote-work-global_svg__cls-1{fill:#000;stroke-width:0}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "remote-work-global_svg__cls-1",
  d: "M79.05 83.28h-53.1c-.69 0-1.25-.56-1.25-1.25V50.99c0-.32.12-.63.34-.86l26.55-28.01c.47-.5 1.34-.5 1.81 0l26.55 28.01c.22.23.34.54.34.86v31.05c0 .69-.56 1.25-1.25 1.25zm-51.85-2.5h50.6v-29.3L52.5 24.79 27.2 51.48v29.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "remote-work-global_svg__cls-1",
  transform: "rotate(-46.54 24.22 52.793)",
  d: "M21.72 51.55h5.01v2.5h-5.01z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "remote-work-global_svg__cls-1",
  transform: "rotate(-43.46 80.782 52.797)",
  d: "M79.52 50.29h2.5v5.01h-2.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "remote-work-global_svg__cls-1",
  d: "M58.53 51.31H46.47c-.69 0-1.25-.56-1.25-1.25v-2.37c0-2.25 1.83-4.08 4.08-4.08h6.4c2.25 0 4.08 1.83 4.08 4.08v2.37c0 .69-.56 1.25-1.25 1.25zm-10.81-2.5h9.56v-1.12c0-.87-.71-1.58-1.58-1.58h-6.4c-.87 0-1.58.71-1.58 1.58v1.12zM56.13 70.19h-7.26c-2.01 0-3.65-1.64-3.65-3.65v-.4c0-2.01 1.64-3.65 3.65-3.65h7.26c2.01 0 3.65 1.64 3.65 3.65v.4c0 2.01-1.64 3.65-3.65 3.65zm-7.26-5.2c-.63 0-1.15.52-1.15 1.15v.4c0 .63.51 1.15 1.15 1.15h7.26c.63 0 1.15-.51 1.15-1.15v-.4c0-.63-.52-1.15-1.15-1.15h-7.26z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "remote-work-global_svg__cls-1",
  d: "M69.61 76.32H35.39c-.69 0-1.25-.56-1.25-1.25v-25c0-.69.56-1.25 1.25-1.25h34.22c.69 0 1.25.56 1.25 1.25v25c0 .69-.56 1.25-1.25 1.25zm-32.97-2.5h31.72v-22.5H36.64v22.5z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "remote-work-global_svg__cls-1",
  d: "M59.12 67.59h-.59v-2.5h.59c5.1 0 9.24-4.15 9.24-9.24v-4.53H36.64v4.53c0 5.1 4.15 9.24 9.24 9.24h.59v2.5h-.59c-6.47 0-11.74-5.27-11.74-11.74v-5.78c0-.69.56-1.25 1.25-1.25h34.22c.69 0 1.25.56 1.25 1.25v5.78c0 6.47-5.27 11.74-11.74 11.74zM75.62 46.05h-2.5V30.3H66.1v5.71h-2.5v-6.96c0-.69.56-1.25 1.25-1.25h9.52c.69 0 1.25.56 1.25 1.25v17z"
});

function SvgRemoteWorkGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "remote-work-global_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 105 105"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgRemoteWorkGlobal;